(function () {
  app.controller("AddAddonsCtrl", [
    "$scope",
    "$timeout",
    function ($scope, $timeout) {
      $scope.init = function () {
        //initializing angular controller
      };

      $scope.onReady = function() {
        // if ($scope.require_credit_card) {
        //   $.get($scope.change_credit_card_user_path, function (rs) {});
        // }
      };
    },
  ]);
}.call(this));
